  document.addEventListener("DOMContentLoaded", function () {
    const swiper = new Swiper("#cst-reviews .mySwiper", {
      loop: true,
      spaceBetween: 16,
      pagination: {
        el: "#cst-reviews .swiper-pagination",
        clickable: true,
      },
      a11y: {
        paginationBulletMessage: "Slayt {{index}}",
      },
      slidesPerView: "auto",
      // breakpoints: {
      //   0: {
      //     slidesPerView: 1.2,
      //   },
      //   768: {
      //     slidesPerView: 2.4,
      //   },
      //   1200: {
      //     slidesPerView: 4.2,
      //   },
      // },
    });
  });
